import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css"; // 👈 importante

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://lider.tutorandy.xyz/php/models.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario: username, clave: password, page: 'login' })
      });

      const data = await res.json();

      if (res.ok && data.status === "ok") {
        try {
          navigate("/dashboard");
        } catch (error) {
          //console.error("Error navegando:", error);
        }
      } else {
        setErrorMsg(data.error || "Usuario o contraseña incorrectos");
        setUsername("");
        setPassword("");
        return;
        //alert(data.error);
      }
    } catch (error) {
      console.error("❌ Error en la solicitud o al procesar la respuesta:", error);
      setErrorMsg("Error del servidor. Intenta nuevamente.");
    }
  };

  return (
    <form className="login-form" onSubmit={handleLogin}>
      <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Usuario" autoComplete="username" />
      <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Contraseña" autoComplete="current-password" />
      <button type="submit">Iniciar sesión</button>
      {errorMsg && <p style={{ color: "red", marginTop: "10px" }}>{errorMsg}</p>}
    </form>
  );
}
